import { render, staticRenderFns } from "./CarouselBox.vue?vue&type=template&id=6c8dd182&scoped=true&"
import script from "./CarouselBox.vue?vue&type=script&lang=js&"
export * from "./CarouselBox.vue?vue&type=script&lang=js&"
import style0 from "./CarouselBox.vue?vue&type=style&index=0&id=6c8dd182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8dd182",
  null
  
)

export default component.exports